import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-SpanLinkModal',
	infoText: 'c-SpanLinkModal__infoText',
	panelContainer: 'c-SpanLinkModal__panelContainer',
	leftPanel: 'c-SpanLinkModal__panelLeft',
	rightPanel: 'c-SpanLinkModal__panelRight',
	panelTitle: 'c-SpanLinkModal__panelTitle',
	panelFooter: 'c-SpanLinkModal__panelFooter',
	spanList: 'c-SpanLinkModal__spanList',
	spanItem: 'c-SpanLinkModal__spanItem',
	createNewOption: 'c-SpanLinkModal__createNew',
	previewContainer: 'c-SpanLinkModal__preview',
	previewEmpty: 'c-SpanLinkModal__previewEmpty',
	emptyMessage: 'c-SpanLinkModal__emptyMessage',
};

// Base style for selectable list items with hidden radio input pattern
const selectableItemBase = {
	position: 'relative',
	display: 'flex',
	'&:hover': {
		'background-color': DefaultTheme.font.color.divider,
	},
	'& input': {
		appearance: 'none',
		'&::-ms-check': {
			display: 'none',
		},
		position: 'absolute',
	},
	'& input + label': {
		width: '100%',
		'border-left': `${DefaultTheme.space(1.5)} solid transparent`,
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		cursor: 'pointer',
	},
	'& input:focus + label': {
		outline: `1px solid ${DefaultTheme.color.accent}`,
		'margin-right': '1px',
	},
	'& input:checked + label': {
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp2,
	},
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		width: '800px',
		height: '550px',
		'min-height': 0,
	},
	[CSS.infoText]: {
		'font-family': DefaultTheme.font.familyCondensed,
		'font-weight': DefaultTheme.font.weight.bold,
		padding: `0 0 ${DefaultTheme.space(2)} ${DefaultTheme.space(2)}`,
		'font-size': '1.2em',
	},
	[CSS.panelContainer]: {
		overflow: 'scroll',
		display: 'flex',
		flex: '1',
	},
	[CSS.leftPanel]: {
		flex: 1,
		'border-right': `1px solid ${DefaultTheme.font.color.divider}`,
		'overflow-y': 'auto',
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.rightPanel]: {
		display: 'flex',
		'flex-direction': 'column',
		flex: 1.5,
		height: '100%',
	},
	[CSS.previewContainer]: {
		flex: '1',
		overflow: 'scroll',
	},
	[CSS.panelTitle]: {
		'font-family': DefaultTheme.font.familyCondensed,
		'font-weight': DefaultTheme.font.weight.bold,
		'padding-bottom': DefaultTheme.space(2),
		'font-size': '1.2em',
	},
	[CSS.panelFooter]: {
		'padding-top': DefaultTheme.space(2),
	},
	[CSS.spanList]: {
		flex: 1,
		'overflow-y': 'auto',
		'background-color': DefaultTheme.background.grey,
	},
	[CSS.spanItem]: selectableItemBase,
	[CSS.createNewOption]: {
		...selectableItemBase,
		marginTop: DefaultTheme.space(2),
		'& input + label': {
			...selectableItemBase['& input + label'],
			'font-weight': DefaultTheme.font.weight.bold,
		},
		'& input:checked + label': {
			...selectableItemBase['& input:checked + label'],
			'border-left': `${DefaultTheme.space(1.5)} solid ${DefaultTheme.color.accent}`,
		},
	},
	[CSS.previewEmpty]: {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		height: '100%',
		color: DefaultTheme.font.color.supporting,
		'font-style': 'italic',
	},
	[CSS.emptyMessage]: {
		padding: DefaultTheme.space(4),
		color: DefaultTheme.font.color.supporting,
		'text-align': 'center',
	},
};
